<template>
  <loading v-if="loading" />

  <div v-else-if="view === 'signup'">
    <div id="wrapper" :class="cssWrapper()">
      <a @click.prevent="$router.replace('/HomePage')">
        <div class="arr">
          <div class="inner"></div>
        </div>
      </a>
      <div class="kv login app covershow"><div class="cover"></div></div>
      <div class="content">
        <div class="stepBox">1</div>
        <h1 class="app">LINE 帳號綁定</h1>
        <div class="titleTxt app">
          <div class="inner">
            <span></span>
            <p>請填寫以下資料</p>
            <span></span>
          </div>
        </div>
        <div class="formBox">
          <form action="javascript:void(0);">
            <input
              type="text"
              class="inputBox"
              placeholder="身分證號 (居留證號、護照號碼)"
              maxlength="20"
              v-model.trim="form.twid"
            />
            <input
              type="text"
              class="inputBox"
              placeholder="西元出生日期 (共8碼)"
              maxlength="8"
              v-model.trim="form.birthdate"
            />
            <input
              type="text"
              class="inputBox"
              autocomplete="tel"
              maxlength="10"
              placeholder="手機號碼 (不含國碼共10碼)"
              v-model.trim="form.phone"
            />
            <div class="checkBox">
              <label class="checkMC">
                <p @click.prevent="btnPolicyNetwork">
                  本人同意 <a>網路服務約定條款</a>以及
                </p>
                <p @click.prevent="btnPolicyPrivacy">
                  <a>隱私權及資訊安全政策</a>
                </p>
                <input type="checkbox" value="同意" v-model.trim="form.agree"/>
                <div class="box"></div
              ></label>
            </div>
            <input
              type="submit"
              class="submitBtn"
              value="下一步"
              @click.prevent="btnSignup"
            />
          </form>
        </div>
        <div class="textBox">
          <p>
            外籍人士請以居留證號、護照號碼填寫。<br />For foreigners, please use
            Resident Certificate ID number or Passport number to register.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div v-else-if="view === 'otp'">
    <div id="wrapper" :class="cssWrapper()">
      <div class="arr" @click.prevent="btnOtpExit">
        <div class="inner"></div>
      </div>
      <div class="kv login app covershow"><div class="cover"></div></div>
      <div class="content">
        <div class="stepBox">2</div>
        <h1 class="app">加入會員</h1>
        <div class="titleTxt app">
          <div class="inner">
            <span></span>
            <p>
              請等候密碼簡訊<br />約 <b>{{ timeout }}</b> 秒
            </p>
            <span></span>
          </div>
        </div>
        <div class="formBox">
          <form action="javascript:void(0);">
            <input
              type="text"
              name="token"
              inputmode="numeric"
              maxlength="4"
              autocomplete="one-time-code"
              class="inputBox onetime"
              placeholder="輸入簡訊驗證碼"
              v-model.trim="form.otp"
            />
            <input
              type="submit"
              class="submitBtn"
              value="下一步"
              @click.prevent="btnOtp"
            />
          </form>
        </div>
      </div>
    </div>
  </div>

  <div v-if="view === 'done'">
    <div id="wrapper" :class="cssWrapper()">
      <div class="kv login app covershow"><div class="cover"></div></div>
      <div class="content">
        <div class="stepBox">3</div>
        <h1 class="app">LINE 帳號綁定成功</h1>
        <div class="doneBox">
          <p style="text-align: justify;">
            恭喜您 !
            您已完成帳號綁定手續，您可以多加利用本系統進行線上預約掛號，本系統將提供多項便利服務，也可供您查詢相關醫療資訊與就診報告。
          </p>
        </div>
        <div class="bottomBtns">
          <div
            class="btn hollow"
            @click.prevent="$router.replace('/guest/line/HomePage')"
          >
            <p class="min">回首頁</p>
          </div>
          <div
            class="btn hollow"
            @click.prevent="$router.replace('/AppointmentQuery')"
          >
            <p class="min">查詢預約紀錄</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <modal v-if="modal.display" @close="modal.display = false">
    <template #header>{{ modal.header }}</template>
    <template #body>{{ modal.body }}</template>
  </modal>

  <debug v-if="debug">{{ member }}</debug>
</template>

<script>
import api from "../api/index";
export default {
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      loading: false,
      modal: {},
      view: "signup",
      form: {},
      timer: null,
      interval: 1000,
      timeout: 60, //自動關閉秒數
      message: null
    };
  },
  computed: {
    member() {
      return this.$store.state.member;
    }
  },
  mounted() {},
  watch: {
    timeout(left) {
      //console.log("Countdown", left);
      if (left < 1) {
        this.btnOtpExit();
      }
    }
  },
  methods: {
    btnSignup() {
      //檢查欄位
      if (!this.form.twid || !/^\w{5,20}$/.test(this.form.twid)) {
        this.modal = {
          display: true,
          body: "身分證格式錯誤，證件號碼需5~20英數字。"
        };
        return false;
      }
      if (
        !/^(19|20)\d\d(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])$/.test(
          this.form.birthdate
        )
      ) {
        this.modal = {
          display: true,
          body: "生日格式錯誤，應為西元年月日共8位數字。"
        };
        return false;
      }
      if (!/^09\d{8}$/.test(this.form.phone)) {
        this.modal = {
          display: true,
          body: "手機格式錯誤，需為09開頭共10位數字。"
        };
        return false;
      }
      if (!this.form.agree) {
        this.modal = {
          display: true,
          body: "請先確認並同意本院會員條款"
        };
        return false;
      }

      //開始綁定, 倒數計時
      this.view = "otp";
      this.timer = setInterval(() => this.timeout--, this.interval);

      api.member
        .bind({
          jwt: this.member.jwt,
          form: this.form
        })
        .then(data => {
          this.message = data.message;
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
          this.btnOtpExit();
        });
    },
    btnOtpExit() {
      clearInterval(this.timer);
      this.timeout = 60;
      this.view = "signup";
    },
    btnOtp() {
      //檢查欄位
      if (!/^\d{4}$/.test(this.form.otp)) {
        this.modal = {
          display: true,
          body: "驗證碼格式錯誤。"
        };
        return false;
      }

      //送出驗證碼
      this.loading = true;
      api.member
        .verify({
          jwt: this.member.jwt,
          form: this.form
        })
        .then(data => {
          console.log(data);
          clearInterval(this.timer); //清除倒數
          this.timeout = 60;
          this.loading = false;
          //會員資料存入Vue store
          this.$store.dispatch("login", {
            platform: this.member.platform, //保留原來的platform
            params: this.member.params //保留原來的route路徑
          });
          this.view = "done";
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
      this.form = {};
    },
    btnPolicyNetwork() {
      this.modal = {
        display: true,
        header: "網路服務約定條款",
        body:
          "歡迎使用木生婦幼診所LINE官方帳號功能服務；請您先詳細閱讀以下約定條款： 本約定條款適用於木生婦幼診所LINE官方帳號功能服務（以下稱本系統），本系統的服務是由『木生婦幼診所』（下稱本院所）所建置提供。 本約定條款的目的，是為了保護「木生婦幼診所」以及您的利益，如果您點選「個人服務」、「開始連結」或類似語意的選項、或在本系統進行登入、查閱、修改資料等相關行為，就視為您事先已經知悉、並同意本約定條款的所有約定。\n\n一、使用者\n1. 如果您要在木生婦幼診所LINE官方帳號功能服務查詢個人醫療資訊時，您必須在首次認證作業中填寫「身分證」、「西元出生日期」、「手機號碼」，使用個人手機取得驗證碼後驗證成功，成功綁定資訊。並同意日後以身份證號碼或其它合法證照號碼、出生日期於本系統進行相關醫療資訊查詢作業。\n2. 您有自行妥善保管您留存於本系統之個人資訊之義務，不得將該個人資訊透露或提供給第三人知悉、或出借或轉讓第三人使用。對於所有您使用功能，本服務系統所為之一切行為，都視為您自己之行為，並應由您負其責任。\n\n二、查詢資訊功能\n1. 木生婦幼診所LINE官方帳號功能服務將確保本系統具有符合一般可合理期待之安全性；但本系統不以任何明示或默示的方式擔保您所傳輸的資料將被正常顯示或處理、亦不擔保資料傳輸的正確性，如果您發現本系統有錯誤或疏失，請立即通知木生婦幼診所。\n2. 本系統會定期備份資料（除超音波影像下載功能資訊），但是除因故意或重大過失所致者外，木生婦幼診所不對任何資料的失誤刪除、或備份錯誤或失敗負責。\n\n三、個人資料安全 依據中華民國個人資料保護法（以下稱個資法）第八條第一項規定，為了確保使用者之個人資料、隱私及權益之保護，當您已申請「木生婦幼診所LINE官方帳號功能服務」時，即表示您願意以電子文件之方式行使法律所賦予同意之權利，並具有書面同意之效果，若不同意請勿申請帳號來進行資訊查詢，如仍需其它服務，請連繫本院所，我們將竭誠為您服務。 (以下為本院所依「個人資料保護法」規定，必須向您告知的各項聲明，請您務必詳閱。) 木生婦幼診所LINE官方帳號功能服務為木生婦幼診所經營管理，為確保消費者之個人資料、隱私及消費者權益之保護，於查詢過程中將使用消費者之個人資料，謹依個人資料保護法第8條規定告知以下事項：\n(一) 個人資料蒐集目的 本院所之蒐集目的在於消費者、客戶管理與服務、保健醫療服務、資(通)訊服務(法定特定目的 項目編號為 090, 064, 135)。\n(二) 個人資料蒐集類別 本院所於系統內蒐集的個人資料包括\n1.C001辨識個人者： 如消費者之姓名、地址、電話、電子郵件等資訊。\n2.C003政府資料中之辨識者： 如身分證字號或居留證號碼（外國人）。\n3.C011個人描述： 如性別、國籍、出生年月日。\n(三) 個人資料利用之期間、地區、對象及方式\n1. 期間：本院所營運期間。\n2. 地區：消費者之個人資料將用於本院所服務之地區。\n3. 對象：本公司之合作推廣院所、業務往來之醫師、相關醫療人員、系統維護人員與提供本公司服務之第三方公司。\n(四) 依據個資法第三條規定，您就本院所保有您的個人資料得行使下列權利 查詢、閱覽、複本、補充、更正、請求停止蒐集、請求停止處理、請求停止利用、請求刪除等權利。 木生婦幼診所保有修訂本告知內容之權利，修正時亦同，以上條文參考自中華民國資料保護協會。"
      };
    },
    btnPolicyPrivacy() {
      this.modal = {
        display: true,
        header: "隱私權及資訊安全政策",
        body:
          "感謝您使用「木生婦幼診所LINE官方帳號功能服務」(以下稱本系統），本系統是由木生婦幼診所進行管理(以下稱本院)。為使您能夠安全的使用本院提供之各項服務與資訊，依據「個人資料保護法」之相關規定與立法精神，特此向您說明本系統的「隱私權保護及資訊安全」政策，以保障您的權益。 當您使用本系統時，務須先行確認是否同意本系統所公布之現行隱私權聲明。如果您不同意本聲明內容，請勿提供本系統提供相關個人資料。\n\n隱私權聲明與個人資料保護條款\n\n請您於使用前詳加閱讀本院將如何使用及保護您的隱私，當您使用或登入本系統，即代表您同意此隱私權聲明及個人資料保護條款(以下稱本條款)，並同意下揭各項權利及義務。 服務之目的及資料使用與範圍\n1. 除法令要求或合於法令規範外，我們不會向任何第三方揭露任何直接關於您個人識別之資訊。\n2. 您所提供之個人資料，僅作為協助您進行預約掛號、預約紀錄查詢，以及本系統相關功能服務。\n\n資料安全\n1. 本系統採用SSL加密技術，並盡力以合理之技術及程序，保障所有個人資料之安全。\n\n資料之蒐集、處理及利用\n1. 在本聲明中，「個人資料」指可辨認個人身份的資料，例如：身分證字號、出生年月日、手機號碼，它的含括範圍「個人資料保護法」之規範。\n2. 若您自願提供個人資料給予本系統時，即表示您同意我們可依據您選擇留存個人資料之該項服務範圍目的來蒐集、處理及利用您的個人資料。此紀錄僅於內部應用做為我們增進本系統服務之參考依據，絶不對外公布。\n\n行為規則\n您同意在使用本服務時，必須遵守本條款或本院的規範或政策，如違反下列行為，本院擁有停用您使用本系統服務之權利，以及保留求償權利，以下為行為規則：\n1. 主張本系統之服務為本院提供之醫療行為服務，或要求為此負賠償責任。\n2. 構成違法之行為。\n3. 侵害他人智慧財產權。\n4. 侮辱、誹謗、騷擾、脅迫、傷害、詐欺、侵害他人隱私之行為及其他侵權之行為。\n5. 非經過當事人同意並假冒身分。\n6. 造成本院之設備不合理之負擔。\n7. 干擾或企圖干擾本服務之正常運作。\n8. 破解或以各種方式繞過任何本院用以防止或限制使用服務（或一部分服務）的措施。\n9. 以破譯、反編譯、逆向工程或其他方式，試圖獲得任何原始或相關資料。\n10. 以任何方式創造任何部分服務的衍生著作品。\n11. 以任何方式轉讓本協議之任何權利。\n\n免責聲明\n1. 您使用本服務所提交的資料，請確認您是資料的擁有者或您有權提供該資料。並請務必確認您所提供資料之真實性。若個人資料有任何異動，請主動於本院進行聯繫，若您提供錯誤、不實、逾時或不具完整性或有誤導性之資料，損及您的權益或造成損害，本院將不擔負任何責任。\n2. 您同意本條款，表示您已閱讀、了解並同意接受本條款之全部內容及其後修訂變更之規定。若您未滿二十歲，當您使用或登入本系統，即視為您已取得法定代理人之同意並同意遵守所有規範。\n\n權利保留\n1. 若您對本聲明有任何疑問，或對所留存之個人資料有任何權利主張，歡迎隨時與我們聯絡\n2. 本院有權隨時修改或變更本服務條款之內容，修改後的服務條款內容將公佈本系統上，將不會進行個別通知，建議使用者應隨時注意該等修改或變更。使用者如在本服務條款修改或變更後繼續使用本APP時，視為使用者已閱讀、瞭解並同意接受該等修改或變更。\n3. 本系統隱私權政策將因應需求隨時進行修正，修正後的條款將刊登於本系統上。"
      };
    },
    cssWrapper() {
      return "noheader signing";
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
};
</script>
